"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.READY_STATE = exports.QUALITY = void 0;
var QUALITY = exports.QUALITY = {
  OFFLINE: 0,
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
  PERFECT: 4
};

// create new Enum because Primus don't have value from enum but in global object
// Primus.OPENING = 1;   // We're opening the connection.
// Primus.CLOSED  = 2;   // No active connection.
// Primus.OPEN    = 3;   // The connection is open.
var READY_STATE = exports.READY_STATE = {
  OPENING: 1,
  CLOSED: 2,
  OPEN: 3
};